module.exports = __webpack_public_path__ + "img/glassquality_3.60518fcb.png";